/*
 * Smooth scroll (Lenis) with auto-detect prevent.
 *
 * Activates when window.__SMOOTH_SCROLL_CONFIG is set by the loader script
 * before this file runs.
 *
 * The `prevent` callback walks up from the wheel/touch target and bails
 * (returning true) if any ancestor is:
 *   1. Marked with [data-lenis-prevent] (explicit opt-out)
 *   2. An open <dialog>, [aria-modal="true"], or visible [role="dialog"]
 *   3. Actually scrollable — overflow: auto/scroll AND has overflow content
 *
 * Result: drawers, modals, popups, filters, and any scrollable inner pane
 * keep their native scroll behavior with zero per-component setup.
 */
(function () {
  'use strict';

  var cfg = (window.__SMOOTH_SCROLL_CONFIG) || {};
  var POLL_MS = 50;
  var MAX_WAIT_MS = 5000;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function waitForLenis(cb, fail) {
    if (window.Lenis) return cb(window.Lenis);
    var elapsed = 0;
    var t = setInterval(function () {
      if (window.Lenis) {
        clearInterval(t);
        cb(window.Lenis);
      } else if ((elapsed += POLL_MS) >= MAX_WAIT_MS) {
        clearInterval(t);
        fail && fail();
      }
    }, POLL_MS);
  }

  function isScrollable(el) {
    if (!el || el.nodeType !== 1) return false;
    var style = window.getComputedStyle(el);
    var oy = style.overflowY;
    var ox = style.overflowX;
    var canY = (oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1;
    var canX = (ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 1;
    return canY || canX;
  }

  function isDialogLike(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName === 'DIALOG' && el.hasAttribute('open')) return true;
    if (el.getAttribute && el.getAttribute('aria-modal') === 'true') return true;
    if (el.getAttribute && el.getAttribute('role') === 'dialog') {
      // Honor aria-hidden on dialog wrappers
      return el.getAttribute('aria-hidden') !== 'true';
    }
    return false;
  }

  function isExplicitPrevent(el) {
    return el && el.nodeType === 1 && el.hasAttribute && el.hasAttribute('data-lenis-prevent');
  }

  function shouldPrevent(node) {
    var el = node;
    var html = document.documentElement;
    while (el && el !== html) {
      if (isExplicitPrevent(el)) return true;
      if (isDialogLike(el)) return true;
      if (isScrollable(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function init(Lenis) {
    if (window.__lenisInstance) return;

    var lenis = new Lenis({
      duration: typeof cfg.duration === 'number' ? cfg.duration : 1.2,
      smoothWheel: true,
      smoothTouch: !!cfg.smoothTouch,
      // Lenis 1.x: any node walked up from this target matching `prevent`
      // returns true → Lenis ignores the wheel/touch and the browser scrolls
      // the inner element natively.
      prevent: shouldPrevent
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Expose for other scripts (e.g., to pause/resume during animations)
    window.__lenisInstance = lenis;

    // Stop Lenis from fighting native programmatic scrolls inside drawers.
    // When a dialog/drawer opens, scroll-locking on <html>/<body> is common;
    // Lenis re-syncs on resize so this keeps things sane.
    window.addEventListener('resize', function () { lenis.resize(); });

    // Re-emit a generic event for any code that wants to react after smooth
    // scroll lands on an anchor.
    lenis.on('scroll', function (e) {
      if (window.requestIdleCallback) {
        // No-op hook; intentionally lightweight
      }
    });
  }

  ready(function () {
    waitForLenis(init, function () {
      // Lenis didn't load — fail silent, browser handles native scroll.
    });
  });
})();
